<template>
  <bean-source-page
    :type="type"
    :filter-columns="filterColumns"
    :form="form"
    :title="$t('model.normalComment')"
    :batch-actions="batchActions"
    resource="normal_comments"
  >
    <template #table="{ value }">
      <Table v-if="value && value.length" :value="value" />
      <div v-else>
        <p style="text-align: center; padding: 50px 0;">暂无数据</p>
      </div>
    </template>
    <template #show="{ value }">
      <ShowPage v-if="value" :value="value" />
    </template>
  </bean-source-page>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend } from '../../admin_grapes/normal_comments.js';
import { modelData } from '@/custom_models_extend';
import _ from 'lodash';
import Table from './table.vue';
import ShowPage from './show-page.vue';

@Component({
  components: {
    Table,
    ShowPage
  }
})
export default class Normalnormal_comments extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const modelNames = [
      'Article',
      'SpecialColumn',
      'SeekTruthWeekly',
      'SeekTruthVideo',
      'BookList',
      'Podcast',
    ]
    const array = [
      'content_cont',
      // { key: 'parent_id_null', label: '一级评论' },
      {
        prop: 'commentable_of_any_type_type_eq',
        label: this.$t('normalComment.commentableType'),
        renderCell: {
          component: 'select',
          props: {
            clearable: true,
            options: _.map(modelNames, (modelName) => ({ label: this.$t(`model.${modelData[modelName]['element']}`), value: modelName }))
          }
        }
      },
      // {
      //   key: 'commentable_id_eq',
      //   renderCell: {
      //     component: 'input',
      //     props: {
      //       clearable: true,
      //       type: 'number'
      //     }
      //   }
      // },
      'deleted_at_not_null',
      'position_not_null',
      'admin_read_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
    * @param {Object} scope -表格 scope 数据
    * @param {Object} scope.selection - 表格已选择行数据
    * @param {Object} sourcePageScope
    * @param {Function} sourcePageScope.remove - sourcePage删除方法
    * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
    */
  batchActions({ selection }, { resource, reload }) {
    const exportClick = async (selection) => {
      if (selection.length === 0) {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query });
      } else {
        await this.$request.get(`/${resource}/export`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
      }

      this.$message.success(this.$t('exporting'));
    }

    const readAll = async (selection) => {
      if (selection.length === 0) {
        await this.$request.post(`/${resource}/batch_read`, { ...this.$route.query });
        reload();
      } else {
        await this.$request.post(`/${resource}/batch_read`, { ...this.$route.query, id_in: _.map(selection, item => item.id) });
        reload();
      }
    }

    return [
      () => <el-button icon="el-icon-download" type='primary' onClick={() => exportClick(selection)}>导出</el-button>,
      () => <el-button icon="el-icon-view" type='warning' onClick={() => readAll(selection)}>本页设为已读</el-button>
    ];
  }
}

export const route = [
  {
    path: '/normal_comments',
    name: 'normal_comments.index',
    component: Normalnormal_comments,
    props: {
      type: 'index',
    }
  },
  {
    path: '/normal_comments/new',
    name: 'normal_comments.new',
    component: Normalnormal_comments,
    props: {
      type: 'new',
    }
  },
  {
    path: '/normal_comments/:id',
    name: 'normal_comments.show',
    component: Normalnormal_comments,
    props: {
      type: 'show',
    }
  },
  {
    path: '/normal_comments/:id/edit',
    name: 'normal_comments.edit',
    component: Normalnormal_comments,
    props: {
      type: 'edit'
    }
  }
]
</script>
